export const cozywarm = {
  name: 'Cozy & Warm',
  color: [0.7098039215686275, 0.11372549019607843, 0.0392156862745098, 1],
  bg: [0.4, 0.13333333333333333, 0.1450980392156863, 1],
  grid1: [0.9176470588235294, 0.8274509803921568, 0.611764705882353, 1],
  grid2: [0.49019607843137253, 0.3686274509803922, 0.23529411764705882, 1],
}
